export { default as Icon } from './icon';
export type { IconName, IconProps } from './icon';

// Single button for the whole app: the call-site API is preserved by an
// adapter that renders ONLY your Primary_Button.
export { default as Button } from './button';
export { default as PrimaryButton } from './primaryButton';
export { default as Input } from './input';
export { default as CommonSearch } from './commonSearch';
export { default as Textarea } from './textarea';
export { default as Select } from './select';
export { default as AppDropdown } from './appDropdown/appDropdown';
export { default as Checkbox } from './checkbox';
export { default as Switch } from './switch';

export { default as Card } from './card';
export { default as StatRow } from './statRow';
export { default as Chip } from './chip';
export { default as Avatar } from './avatar';
export { default as Tabs } from './tabs';
export { default as Modal } from './modal';
export { default as ConfirmDialog } from './confirmDialog';
export { default as SuccessDialog } from './successDialog';
export { default as Alert } from './alert';
export { useToast } from './toast';

export { default as Empty } from './empty';
export { default as PageHeader } from './pageHeader';
export { default as Popover } from './popover';
export { default as MenuItem, MenuSeparator } from './menuItem';
export { default as StateBadge } from './stateBadge';
export { default as ConfBar } from './confBar';
export { default as Thumb } from './thumb';
export { default as QuotaBar } from './quotaBar';
